// extracted by mini-css-extract-plugin
export default {"Wrapper":"ISDataEntryCongrats_Wrapper__JM05V","Buttons":"ISDataEntryCongrats_Buttons__VZr0a"};